import { List } from "@mui/material";
import React from "react";
import { ChatMessage } from "../../types";
import { MessageItem } from "./MessageItem";

interface MessageListProps {
  messages: ChatMessage[];
  onExecuteAction?: (actionId: string) => void;
  onIgnoreAction?: (actionId: string) => void;
  executingActions?: Set<string>;
  agentNames?: { [agentId: string]: string };
  agentAvatars?: { [agentId: string]: string | undefined };
  userTimezone?: string;
}

export const MessageList: React.FC<MessageListProps> = ({ messages, onExecuteAction, onIgnoreAction, executingActions, agentNames, agentAvatars, userTimezone }) => (
  <List>
    {messages.map((message) => (
      <MessageItem
        key={message.id}
        message={message}
        onExecuteAction={onExecuteAction}
        onIgnoreAction={onIgnoreAction}
        executingActions={executingActions}
        agentNames={agentNames}
        agentAvatars={agentAvatars}
        userTimezone={userTimezone}
      />
    ))}
  </List>
);
